import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M20.61 21.86l-5.17-5.52a.67.67 0 0 1-.18-.44V7.68h1.3v8l5 5.33z' }),
  React.createElement('path', { d: 'M16 28.76A12.76 12.76 0 1 1 28.76 16 12.77 12.77 0 0 1 16 28.76zm0-24.22A11.46 11.46 0 1 0 27.46 16 11.47 11.47 0 0 0 16 4.54z' })
));